// extracted by mini-css-extract-plugin
module.exports = {"container":"_43d8","video":"_87d4","backVideo":"e006","image":"d436","iconDiv":"_9572","icon":"_1aad","textBox":"_3bed","button":"a71c"};